import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpContext } from '@angular/common/http';
import { ApiResponse, USE_ALL_SITES } from '@card-software/nexus-utilities';
import { InventoryType } from '../../models/inventory/inventory-type';

@Injectable({
  providedIn: 'root',
})
export class InventoryTypeProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.inventoryApi + '/api/v1/inventory-type';

  public getAllInventoryType(siteId?: string, useAllSites = false): Observable<ApiResponse<InventoryType[]>> {
    const url = siteId ? `${this.baseUrl}/all?siteId=${encodeURIComponent(siteId)}` : `${this.baseUrl}/all`;
    const context = new HttpContext().set(USE_ALL_SITES, useAllSites);
    return this.httpClient.get<ApiResponse<InventoryType[]>>(url, { context });
  }
}
